'use client';

import { useLayoutEffect } from 'react';
import { cn } from '@lib/utils';
import { getNeighborDays } from '../../_const/stories';
import { DIALOG_CLASS, StoryDialogControls } from './story-dialog-controls';
import StoryHeader from './story-header';
import StoryMedia, { StoryMediaPoster } from './story-media';
import {
  clearOpeningStory,
  getStoryBackdrop,
  useOpeningStory,
} from '../../_utils/story-transition';

/** 누른 즉시 뜨는 임시 모달 — 라우트 모달이 올 때까지 자리를 지키는 조작 불가 복제본(패널 inert) */
export default function StoryDialogPlaceholder({
  stories,
}: {
  // 공개된 스토리(Day 순)와 포스터
  stories: { day: number; poster: string }[];
}) {
  const opening = useOpeningStory();

  useLayoutEffect(function clearWhenReplaced() {
    return clearOpeningStory;
  }, []);

  if (opening === null) return null;
  const { prev, next } = getNeighborDays(
    stories.map(story => story.day),
    opening,
  );
  const poster = stories.find(story => story.day === opening)?.poster;

  return (
    <div aria-hidden className={cn(DIALOG_CLASS.scroller, 'z-[10000]')}>
      <div className={DIALOG_CLASS.backdrop} />
      {/* inert 는 클릭을 통과시킨다 — 패널에만 걸어 클릭이 페이지가 아니라 배경에 닿게 한다 */}
      <div inert className={DIALOG_CLASS.panel}>
        <StoryDialogControls
          prevDisabled={prev === undefined}
          nextDisabled={next === undefined}
        />
        <StoryMedia>
          {poster && (
            <StoryMediaPoster
              src={poster}
              backdrop={getStoryBackdrop(opening, poster)}
            />
          )}
        </StoryMedia>
        <div className="ty-story-body">
          <StoryHeader day={opening} />
        </div>
      </div>
    </div>
  );
}
